'use strict';

const isProduction = "development" === 'production';

const Vue = require('vue');
const VueX = require('vuex');
const VueXStore = require('./product-configurator-store');
const axios = require('axios');
const ProductPageHandler = require('../../product-page-handler');
const addToCart = require('../../pages/product/addToCart');
const configuratorVueEl = '#product-configurator';
const configuratorAppEl = '.js-product-configurator';
const configuratorAppTriggerEl = '.js-product-configurator-trigger';

let configurator = false;
const props = {
    'productId': '',
    'configurationId': '',
    'productConfiguration': '',
    'actionType': '',
    'actionData': ''
};

/**
 * Initialise the global Vue properties.
 */
const initVue = () => {
    Vue.use(VueX);
};

/**
 * Setup eventbus to allow configurator comminication with configurator
 */
const initEventBus = () => {
    window.eventBus = window.eventBus || new Vue();

    window.eventBus.$on('addConfiguredProductToCart', (data) => {
        const url = window.Urls.addProduct.toString() || '';
        axios.post(
            url,
            {},
            {
                params: {
                    pid: data.product,
                    childPids: Object.keys(data.selectedComponents).map(key => data.selectedComponents[key].id).join(','),
                    personalizedName: data.personalizedName,
                }
            }
        ).then((result) => {
            if (data.actionType == 'updatePDP') {
                ProductPageHandler.updatePage(data);
            }
            $('.js-product-image-mobile').attr('data-src', data.primaryImage.src);
            addToCart.updateMiniCartOnAddProduct(result.data, false);
        });
    });

    window.eventBus.$on('configuratorChanged', (data) => {
        let queryString = '';
        switch (data.actionType) {
            // Redirects to a given page and adds the selected configuration as a QueryString
            case 'redirectTo':
                queryString = data.updateData.urlParameterName + '=';
                if (data.updateData && data.updateData.isTalisman) {
                    queryString += String.format(data.updateData.urlParameterValueFormat, data.product,
                        data.selectedComponents.fragrance.id, data.selectedComponents.bottle.id,
                        data.selectedComponents.cap.id, data.selectedComponents.talisman.id);
                } else {
                    queryString += String.format(data.updateData.urlParameterValueFormat, data.product,
                        (data.selectedComponents.fragrance || data.selectedComponents.wax).id,
                        (data.selectedComponents.bottle || data.selectedComponents.candleholder).id);
                }

                location.href = `${data.actionData}?${queryString}`;
                break;

            // Updates the PDP with the selected configuration
            case 'updatePDP':
                ProductPageHandler.updatePage(data);
                break;
            default:
                break;
        }
    });

    window.eventBus.$on('configuratorClosed', () => {
        destroyConfigurator();
    });

    window.onpopstate = () => {
        window.eventBus.$emit('shouldCloseConfigurator');
    };
};

/**
 * Add click events to all triggers on page
 */
const initTriggers = () => {
    $(document).on('click', configuratorAppTriggerEl, onClickTrigger);
};

/**
 * Handles click event on trigger element
 * @param {Event} e Event object
 */
const onClickTrigger = (e) => {
    e.stopPropagation();
    if (isConfiguratorActive()) {
        return false;
    }

    props.productId = $(e.currentTarget).data('product-id');
    props.configurationId = $(e.currentTarget).data('configuration-id');
    props.productConfiguration = $(e.currentTarget).data('product-configuration');
    props.actionType = $(e.currentTarget).data('action-type') || '';
    props.actionData = $(e.currentTarget).data('action-data') || '';

    history.pushState('', '', window.location.href);

    prepareMarkup();
    createConfigurator();
};

/**
 * Prepares the markup for the configurator to be attached to
 */
const prepareMarkup = () => {
    const template = `
        <div id="app-configurator" class="${configuratorAppEl.substr(1)}">
        </div>
    `;

    $('body').append(template);
};

/**
 * Creates the Product Configurator App
 */
const createConfigurator = () => {
    const ProductConfigurator = require('./product-configurator/product-configurator.vue');
    const store = VueXStore.init(VueX);

    configurator = new Vue({
        el: configuratorAppEl,
        store,

        components: {
            ProductConfigurator
        },

        computed: {
            isProduction() {
                return isProduction;
            },

            productId() {
                return props.productId.toString();
            },

            configurationId() {
                return props.configurationId;
            },

            productConfiguration() {
                return JSON.stringify(props.productConfiguration);
            },

            actionType() {
                return props.actionType;
            },

            actionData() {
                return props.actionData;
            }
        },

        template: `
            <product-configurator
                :isProduction="isProduction"
                :productId="productId"
                :configurationId="configurationId"
                :productConfiguration="productConfiguration"
                :actionType="actionType"
                :actionData="actionData">
            </product-configurator>
        `
    });
};

/**
 * Removes the Product Configurator App from the DOM
 */
const destroyConfigurator = () => {
    configurator = false;
    $(configuratorVueEl).remove();
};

/**
 * Tests if we already have a configurator present
 * @returns {Boolean} result of test
 */
const isConfiguratorActive = () => {
    return configurator !== false;
};

/**
 * Tests if the product configurator should init
 * @returns {Boolean} result of test
 */
const shouldInit = () => {
    return $(configuratorAppTriggerEl).length > 0;
};

const productConfiguratorApp = {
    init: () => {
        if (shouldInit()) {
            initVue();
            initEventBus();
            initTriggers();
        }
    }
};

module.exports = productConfiguratorApp;
